import React from "react";
import { Phone, ArrowRight, Mail } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

// Import image
import ctaImage from "@/assets/images/cta.png";

export default function CTASection() {
  const { ref, visible } = useScrollReveal();

  const scrollToQuote = () => {
    const el = document.getElementById("quote");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section ref={ref} className="relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={ctaImage}
          alt="Freshly poured concrete with workers"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[hsl(var(--navy))]/95 via-[hsl(var(--navy))]/85 to-[hsl(var(--navy))]/70" />
      </div>

      {/* Content */}
      <div
        className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 text-center transition-all duration-700 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <h2 className="headline text-white text-5xl sm:text-6xl md:text-7xl mb-2">
          Have a Concrete Project?
        </h2>
        <p className="headline text-3xl sm:text-4xl md:text-5xl mb-6 text-[#194d32]">
          Let&apos;s Build It Right.
        </p>
        <p className="text-white/80 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto mb-8">
          Whether you need a new driveway, foundation, slab, patio or other
          concrete work, contact NCC and tell us about your project.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => {
              if (typeof window.gtag === "function") {
                window.gtag("event", "request_estimate", {
                  event_category: "engagement",
                  event_label: "CTA Section Button",
                });
              }
              scrollToQuote();
            }}
            className="group flex items-center justify-center gap-2 hover:bg-white text-white hover:text-[hsl(var(--navy))] font-heading text-lg tracking-wider px-8 py-4 rounded-sm transition-all hover:shadow-2xl focus-ring bg-[#194d32]"
          >
            Request a Free Estimate
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href="mailto:naturalconcrete.contruction@gmail.com"
            onClick={() => {
              if (typeof window.gtag === "function") {
                window.gtag("event", "contact_email", {
                  event_category: "engagement",
                  event_label: "CTA Section Email",
                });
              }
            }}
            className="flex items-center justify-center gap-2 border-2 border-white/40 hover:border-white hover:bg-white/10 text-white font-heading text-lg tracking-wider px-8 py-4 rounded-sm transition-all focus-ring"
          >
            <Mail size={20} />
            Send Email
          </a>
        </div>
      </div>
    </section>
  );
}